module.exports = __webpack_public_path__ + "img/back-labeling.b0744d09.png";